<div class="plm-page">
  <header class="plm-header">
    <div>
      <h1>Resource map</h1>
      <p>Assign crew, machines, and tools to a chainage span. Issue tools and consumables against work locations.</p>
    </div>
  </header>

  <div class="plm-toolbar">
    <mat-form-field appearance="outline">
      <mat-label>Project</mat-label>
      <mat-select [(ngModel)]="projectId" (selectionChange)="onProject()">
        <mat-option [value]="null">All</mat-option>
        <mat-option *ngFor="let p of projects" [value]="p.id">{{ p.project_name || p.project_identifier || p.id }}</mat-option>
      </mat-select>
    </mat-form-field>
  </div>

  <mat-tab-group>
    <mat-tab label="Crew / machine / span">
      <div class="plm-card">
        <form class="plm-form" (ngSubmit)="addMap()">
          <mat-form-field appearance="outline">
            <mat-label>Work location</mat-label>
            <mat-select [(ngModel)]="mapForm.work_location_id" name="mwl">
              <mat-option *ngFor="let l of locations" [value]="l.id">{{ l.location_name || l.location_code || l.id }}</mat-option>
            </mat-select>
          </mat-form-field>
          <mat-form-field appearance="outline">
            <mat-label>Crew</mat-label>
            <input matInput [(ngModel)]="mapForm.crew_label" name="crew" required />
          </mat-form-field>
          <mat-form-field appearance="outline">
            <mat-label>Machine id</mat-label>
            <input matInput type="number" [(ngModel)]="mapForm.machine_id" name="mid" />
          </mat-form-field>
          <mat-form-field appearance="outline">
            <mat-label>Tool</mat-label>
            <mat-select [(ngModel)]="mapForm.tool_id" name="mtid">
              <mat-option [value]="''">None</mat-option>
              <mat-option *ngFor="let t of tools" [value]="t.id">{{ t.tool_name }}</mat-option>
            </mat-select>
          </mat-form-field>
          <mat-form-field appearance="outline">
            <mat-label>Shift</mat-label>
            <mat-select [(ngModel)]="mapForm.shift" name="shift">
              <mat-option value="day">Day</mat-option>
              <mat-option value="night">Night</mat-option>
            </mat-select>
          </mat-form-field>
          <button mat-raised-button color="primary" type="submit">Assign</button>
        </form>
        <table mat-table [dataSource]="resources">
          <ng-container matColumnDef="crew">
            <th mat-header-cell *matHeaderCellDef>Crew</th>
            <td mat-cell *matCellDef="let row">{{ row.crew_label }}</td>
          </ng-container>
          <ng-container matColumnDef="loc">
            <th mat-header-cell *matHeaderCellDef>Location</th>
            <td mat-cell *matCellDef="let row">{{ row.work_location_id || '—' }}</td>
          </ng-container>
          <ng-container matColumnDef="machine">
            <th mat-header-cell *matHeaderCellDef>Machine</th>
            <td mat-cell *matCellDef="let row">{{ row.machine_id || '—' }}</td>
          </ng-container>
          <ng-container matColumnDef="shift">
            <th mat-header-cell *matHeaderCellDef>Shift</th>
            <td mat-cell *matCellDef="let row">{{ row.shift }}</td>
          </ng-container>
          <tr mat-header-row *matHeaderRowDef="['crew','loc','machine','shift']"></tr>
          <tr mat-row *matRowDef="let row; columns: ['crew','loc','machine','shift']"></tr>
        </table>
        <p *ngIf="!resources.length" class="empty-msg">No resource assignments yet.</p>
      </div>
    </mat-tab>

    <mat-tab label="Tools">
      <div class="plm-card">
        <form class="plm-form" (ngSubmit)="addTool()">
          <mat-form-field appearance="outline">
            <mat-label>Code</mat-label>
            <input matInput [(ngModel)]="toolForm.tool_code" name="tc" required />
          </mat-form-field>
          <mat-form-field appearance="outline">
            <mat-label>Name</mat-label>
            <input matInput [(ngModel)]="toolForm.tool_name" name="tn" required />
          </mat-form-field>
          <mat-form-field appearance="outline">
            <mat-label>Category</mat-label>
            <input matInput [(ngModel)]="toolForm.category" name="tcat" />
          </mat-form-field>
          <button mat-raised-button color="primary" type="submit">Add tool</button>
        </form>
        <form class="plm-form" (ngSubmit)="issueTool()">
          <mat-form-field appearance="outline">
            <mat-label>Tool</mat-label>
            <mat-select [(ngModel)]="issueForm.tool_id" name="itid" required>
              <mat-option *ngFor="let t of tools" [value]="t.id">{{ t.tool_name }}</mat-option>
            </mat-select>
          </mat-form-field>
          <mat-form-field appearance="outline">
            <mat-label>Qty</mat-label>
            <input matInput type="number" [(ngModel)]="issueForm.qty" name="iqty" />
          </mat-form-field>
          <mat-form-field appearance="outline">
            <mat-label>Issued to</mat-label>
            <input matInput [(ngModel)]="issueForm.issued_to" name="ito" />
          </mat-form-field>
          <mat-form-field appearance="outline">
            <mat-label>Location</mat-label>
            <mat-select [(ngModel)]="issueForm.work_location_id" name="iwl">
              <mat-option *ngFor="let l of locations" [value]="l.id">{{ l.location_name || l.id }}</mat-option>
            </mat-select>
          </mat-form-field>
          <button mat-stroked-button color="primary" type="submit">Issue</button>
        </form>
        <table mat-table [dataSource]="toolIssues">
          <ng-container matColumnDef="tool">
            <th mat-header-cell *matHeaderCellDef>Tool</th>
            <td mat-cell *matCellDef="let row">{{ row.tool_name || row.tool_id }}</td>
          </ng-container>
          <ng-container matColumnDef="qty">
            <th mat-header-cell *matHeaderCellDef>Qty</th>
            <td mat-cell *matCellDef="let row">{{ row.qty }}</td>
          </ng-container>
          <ng-container matColumnDef="to">
            <th mat-header-cell *matHeaderCellDef>To</th>
            <td mat-cell *matCellDef="let row">{{ row.issued_to }}</td>
          </ng-container>
          <tr mat-header-row *matHeaderRowDef="['tool','qty','to']"></tr>
          <tr mat-row *matRowDef="let row; columns: ['tool','qty','to']"></tr>
        </table>
        <p *ngIf="!toolIssues.length" class="empty-msg">No tool issues.</p>
      </div>
    </mat-tab>

    <mat-tab label="Consumables">
      <div class="plm-card">
        <form class="plm-form" (ngSubmit)="issueConsumable()">
          <mat-form-field appearance="outline">
            <mat-label>Material id</mat-label>
            <input matInput type="number" [(ngModel)]="consForm.material_id" name="cmid" />
          </mat-form-field>
          <mat-form-field appearance="outline">
            <mat-label>Qty</mat-label>
            <input matInput type="number" [(ngModel)]="consForm.qty" name="cqty" required />
          </mat-form-field>
          <mat-form-field appearance="outline">
            <mat-label>UOM</mat-label>
            <input matInput [(ngModel)]="consForm.uom" name="cuom" />
          </mat-form-field>
          <mat-form-field appearance="outline">
            <mat-label>Location</mat-label>
            <mat-select [(ngModel)]="consForm.work_location_id" name="cwl">
              <mat-option *ngFor="let l of locations" [value]="l.id">{{ l.location_name || l.id }}</mat-option>
            </mat-select>
          </mat-form-field>
          <button mat-raised-button color="primary" type="submit">Issue</button>
        </form>
        <table mat-table [dataSource]="consumables">
          <ng-container matColumnDef="mat">
            <th mat-header-cell *matHeaderCellDef>Material</th>
            <td mat-cell *matCellDef="let row">{{ row.material_id }}</td>
          </ng-container>
          <ng-container matColumnDef="qty">
            <th mat-header-cell *matHeaderCellDef>Qty</th>
            <td mat-cell *matCellDef="let row">{{ row.qty }} {{ row.uom }}</td>
          </ng-container>
          <tr mat-header-row *matHeaderRowDef="['mat','qty']"></tr>
          <tr mat-row *matRowDef="let row; columns: ['mat','qty']"></tr>
        </table>
        <p *ngIf="!consumables.length" class="empty-msg">No consumable issues.</p>
      </div>
    </mat-tab>

    <mat-tab label="Contractors">
      <div class="plm-card">
        <form class="plm-form" (ngSubmit)="addContractor()">
          <mat-form-field appearance="outline">
            <mat-label>Vendor id</mat-label>
            <input matInput type="number" [(ngModel)]="contractorForm.vendor_id" name="vid" required />
          </mat-form-field>
          <mat-form-field appearance="outline">
            <mat-label>Package</mat-label>
            <input matInput [(ngModel)]="contractorForm.package_code" name="pkg" />
          </mat-form-field>
          <mat-form-field appearance="outline">
            <mat-label>Role</mat-label>
            <input matInput [(ngModel)]="contractorForm.role" name="crole" />
          </mat-form-field>
          <mat-form-field appearance="outline">
            <mat-label>Location</mat-label>
            <mat-select [(ngModel)]="contractorForm.work_location_id" name="cwl2">
              <mat-option *ngFor="let l of locations" [value]="l.id">{{ l.location_name || l.id }}</mat-option>
            </mat-select>
          </mat-form-field>
          <button mat-raised-button color="primary" type="submit">Assign</button>
        </form>
        <table mat-table [dataSource]="contractors">
          <ng-container matColumnDef="v">
            <th mat-header-cell *matHeaderCellDef>Vendor</th>
            <td mat-cell *matCellDef="let row">{{ row.vendor_id }}</td>
          </ng-container>
          <ng-container matColumnDef="pkg">
            <th mat-header-cell *matHeaderCellDef>Package</th>
            <td mat-cell *matCellDef="let row">{{ row.package_code }} ({{ row.role }})</td>
          </ng-container>
          <tr mat-header-row *matHeaderRowDef="['v','pkg']"></tr>
          <tr mat-row *matRowDef="let row; columns: ['v','pkg']"></tr>
        </table>
        <p *ngIf="!contractors.length" class="empty-msg">No contractor assignments.</p>
      </div>
    </mat-tab>
  </mat-tab-group>
</div>
